export const OpacityContainer = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={className} style={{ opacity: 0.5 }}>
      {children}
    </div>
  );
};